import { useTranslation } from 'react-i18next';
import { scenarios } from '@/mocks/homeData';

export default function ScenariosSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            {t('home.scenarios.title')}
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            {t('home.scenarios.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
          {scenarios.map((scenario) => (
            <article
              key={scenario.id}
              className="group flex flex-col lg:flex-row gap-5 p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-full lg:w-48 h-40 lg:h-32 flex-shrink-0 rounded-md overflow-hidden">
                <img
                  src={scenario.image}
                  alt={scenario.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100">
                    <i className={`${scenario.icon} text-accent-600 text-sm`}></i>
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-950">
                    {scenario.title}
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {scenario.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}